module.exports = __webpack_public_path__ + "img/in-heatmap.1fa585fd.png";